import { render, staticRenderFns } from "./PriceDetails.vue?vue&type=template&id=218b0996&"
import script from "./PriceDetails.vue?vue&type=script&lang=js&"
export * from "./PriceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports